// lib/studio-layer-density.ts
// World units per bitmap pixel of a layer, the measure the resolution heatmap reads: its rect width
// over its bitmap width, else its own scale. null when neither says anything.
export const resolveLayerWorldPerPixel = (
  rectW: number | null | undefined,
  bitmapWidth: number | null | undefined,
  scale: number | null | undefined,
): number | null => (
  typeof rectW === 'number' && rectW > 0 && typeof bitmapWidth === 'number' && bitmapWidth > 0
    ? rectW / bitmapWidth
    : (scale || null)
);
